<div class="row text-primary py-4 container mx-auto">
  <div class="col-12 col-md-3">
    <div class="bg-white rounded p-3 text-center">
      <h4>Questions</h4>
      <div class="d-flex justify-content-center align-items-center flex-wrap mt-2">
        <ng-container *ngFor="let item of questions; index as i; trackBy: trackByIndex">
          <ng-container *ngFor="let question of item.sentences; index as j; trackBy: trackByIndex">
            <div class="question-pin shadow rounded-circle d-flex justify-content-center align-items-center bolder m-2"
                 [class.bg-primary]="isAnswered(question)"
                 [class.text-white]="isAnswered(question)">
              {{ getIndex(i, j) }}
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-9">
    <div class="bg-white rounded p-4">
      <h4 class="mb-2">Reading Part 6 - Text Completion</h4>
      <p>
        In this part, you'll see 4 reading texts and answer 16 multiple choice questions. Each reading text is followed by 4 multiple choice questions. A word, phrase, or sentence is missing in parts of each text. Your task is select the best answer to complete the missing part.      </p>
      <p>
        There are 16 questions in this test.
      </p>
    </div>

    <!-- Questions -->
    <div class="bg-white rounded p-4 mt-3" *ngFor="let question of questions; index as i; trackBy: trackByIndex">
      <h5 class="mb-3 bolder">{{ i+1 }}.</h5>
      <div class="row my-2">
        <div class="col-6">
          <ng-container *ngFor="let sentence of question.sentences; trackBy: trackByIndex">
            <p [innerHTML]="sentence.translation"></p>
          </ng-container>
        </div>
        <div class="col-6 d-flex flex-column justify-content-evenly">
          <ng-container *ngFor="let sentence of question.sentences; index as indexSentence; trackBy: trackByIndex">
            <div class="my-3">
              <h5 class="mb-2">{{indexSentence+1}}.</h5>
              <ng-container *ngFor="let answer of sentence.answers; let sentenceIndex = index">
                <button class="btn rounded btn-block shadow bolder mx-2 text-left p-3 d-flex align-items-center"
                        [class.btn-primary]="isSelected(sentence, answer)"
                        [class.text-white]="isSelected(sentence, answer)"
                        [class.btn-white]="!isSelected(sentence, answer)"
                        [class.text-primary]="!isSelected(sentence, answer)"
                        (click)="selectAnswer(sentence, answer)">
                  <span class="mr-3 bolder">{{ letters[sentenceIndex] }}</span> {{answer.translation}}
                </button>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>


    <button class="btn btn-primary btn-block bolder mt-3" (click)="next()" translate>Suivant</button>
  </div>
</div>
